/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * UndoIcon
 */
export default class UndoIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M22.4 8.667c-.9-2.5-2.7-4.5-5.1-5.7-2.4-1.1-5.1-1.3-7.7-.4-1.3.5-2.5 1.2-3.7 2.3L3 7.667v-3.7c0-.6-.4-1-1-1s-1 .4-1 1v6.3c0 .1.1.1.1.2 0 0 0 .1.1.1l.2.2s.1 0 .1.1h.1c.2.1.3.1.4.1h6c.6 0 1-.4 1-1s-.4-1-1-1H4.5l2.8-2.7c.9-.8 2-1.5 3.1-1.9 2-.7 4.2-.6 6.2.3 1.9.9 3.4 2.5 4.1 4.5 1.4 4.2-.7 8.7-4.9 10.2-4.3 1.6-8.8-.6-10.4-4.7-.2-.5-.8-.8-1.3-.6-.5.2-.8.8-.6 1.3 1.5 4.1 5.4 6.6 9.5 6.6 1.1 0 2.2-.2 3.3-.6 5.3-1.8 7.9-7.5 6.1-12.7z"/><g fillRule="evenodd"><use/><use fillRule="nonzero"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

